import LogToSentry from './sentry';

export type TCapturableError = Error | React.ErrorInfo;

export enum ESeverity {
  High,
  Medium,
  Low
}

export type TPrimitive = number | string | boolean | bigint | symbol | null | undefined;

export type TPrimitiveObject = {
  [key: string]: TPrimitive;
};

export interface IOptions {
  location: string;
  severity: ESeverity;

  // TODO: [chris hunter] - expand on this with user etc etc etc
}

export type TErrorLogger = (errors: TCapturableError[], options?: Partial<IOptions>) => string[];

const ErrorLogger: TErrorLogger = (errors, options = {}) => {
  return [
    // ...LogToSentry(errors, options).map((entry) => `[Sentry] - ${entry}`)
  ];
};

export default ErrorLogger;
